import { createSlice } from "@reduxjs/toolkit";

const authUser = {
  user: {},
  isAuthenticated: false,
  isMenuOpen: true,
  isRightSidebarOpen: false,
  stripeKey: "",
};

const AuthSlice = createSlice({
  name: "Auth",
  initialState: authUser,
  reducers: {
    toggleMenu: (state, action) => {
      state.isMenuOpen = action.payload.menuState;
    },
    toggleRightSidebar: (state, action) => {
      state.isRightSidebarOpen = action.payload.rightSidebar;
    },
    loginUser: (state, action) => {
      state.user = action.payload.user;
      state.accessToken = action.payload.accessToken;
      state.isAuthenticated = action.payload.isAuthenticated;
    },
    updateUser: (state, action) => {
      state.user = action.payload.user;
    },
    logoutUser: (state) => {
      state.user = {};
      state.accessToken = "";
      state.isAuthenticated = false;
    },
    setStripeKey: (state, action) => {
      state.stripeKey = action.payload.key || "";
    },
  },
});

export const {
  loginUser,
  updateUser,
  logoutUser,
  toggleMenu,
  toggleRightSidebar,
  setStripeKey,
} = AuthSlice.actions;

export default AuthSlice.reducer;
